// Hero.js
import React from 'react';
import './Hero.css';
import ImageSlider from './ImageSlider';
import Tittle from './Tittle';
import Btn from './Btn';
import ScrollEffect from './ScrollEffect';


const Hero = ({ images, description1, description2, brandStoryImage }) => {
  return (
    <>
      {/* Hero Container */}
      <div className="hero-container">
        
        <ImageSlider images={images} />
      </div>

      {/* Section 2 */}
      
      <div className="sec-2">
        {/* Title */}
        <ScrollEffect fadeType='fade-up'>
          <Tittle title="BRAND STORY" />
       

        {/* Content Container */}
        <div className="content-container">
          <div className="left-container">
            <p className="para1">{description1}</p>
            <p className="para2">{description2}</p>
          </div>
          <div className="right-container">
            <Btn />
          </div>
        </div>
        

        {/* Image */}
      
        <div className="image-div">
          <img src={brandStoryImage} alt="Brand Story" />
        </div>
        </ScrollEffect>
      </div>
      

     
    
    </>
  );
};

export default Hero;
